export default {
  getToken: "/Token/getToken", // 获取token
  GRTrainProof: "/GetRequest/trainProof", //培训证书详情
  Login: "/User/login", //登录
  Logout: "/User/logout", //退出登录
  HomeInfo: "/Home/homeInfo", //首页信息
  HomeClassList: "/Ppe/classList", //救援技能分类
  RescueList: "/Home/rescueList", //所有救援列表
  RescueDetails: "/Home/rescueDetails", //救援详情
  TrainList: "/Home/trainList", //所有培训列表
  TrainDetails: "/Home/trainDetails", //培训详情
  TrainDetails2: "/Train/trainDetails", //培训详情
  TrainScreen: "/User/trainScreen", //筛选课程
  UserScreen: "/User/userScreen", //队员筛选列表
  UserAdd: "/User/addUser", //添加队员
  TeamInfo: "/Team/teamInfo", //队伍信息
  TeamInfoDetail: "/Team/teamInfoDetail", //队伍信息-查看明细
  TeamAll: "/Team/teamAll", // 多队管理
  TeamStatus: "/Team/teamStatus", // 队伍状态
  TeamDetails: "/Team/teamDetails", // 团队
  TeamAllDel: "/Team/teamAllDel", //注销队伍管理列表
  GetTeamAllUserDel: "/Team/getTeamAllUserDel", //注销队伍管理（队员列表）
  TeamUserRestore: "/Team/teamUserRestore", //注销队伍队员恢复
  EditTeamInfo: "/Team/editTeamInfo", // 编辑队伍信息5
  GetAdminCaseReportList: "/CaseReport/adminCaseReportList", // 编辑队伍信息5
  GetAdminCaseReportDetail: "/CaseReport/adminCaseReportDetail", // 获取接案详情
  SetTeamInfo: "/Team/setTeamOrganization", // 编辑队伍信息6
  GetTeamAllUser: "/Team/getTeamAllUser", // 省队管理
  AddTeam: "/Team/addTeam", // 添加队伍
  AddteamInfo: "/Team/addteamInfo", // 添加队伍-队伍信息
  TeamMember: "/Team/getCaseTeamUser", // 列取队伍所有队员信息
  SetTeamMember: "/Team/setCaseAccepter", // 设置队伍接案人
  GetTeamUser: "/Team/getTeamUser", // 队伍队员列表
  UserInfo: "/User/userInfo", // 个人信息
  UserInfoAlter: "/User/userInfoAlter", // 编辑队员信息（省级）
  UserInfoEdit: "/User/userInfoEdit", // 修改个人信息
  UserBasicInfo: "/User/userBasicInfo", // 个人基本信息
  UpdatePwd: "/User/updatePwd", // 修改密码
  UserAuditList: "/User/userAuditList", // 队员信息审核列表
  UserInfoFill: "/User/userInfoFill", // 个人信息填写(首次登录)
  UserCardNameSave: "/User/cardNameSave", // 修改身份证/姓名
  UserUntiedApplets: "/User/untiedApplets", // 修改小程序
  UserSearchBsrno: "/User/searchBsrno", // 搜索编号
  UserTeamIsRegister: "/User/teamIsRegister", // 查询队伍是否上传营业执照

  StatusAudit: "/User/statusAudit", //  队员信息审核
  CorrectPinyin: "/User/correctPinyin", // 拼音纠错
  correctXueXing: "/User/correctXueXing", // 血型纠错
  OListing: "/Organization/listing", // 发证机构列表
  OAdd: "/Organization/add", // 添加发证机构
  OAuditList: "/Organization/auditList", // 发证机构审核列表
  OAudit: "/Organization/audit", // 发证机构审核
  OAgencyList: "/Organization/agencyList", // 添加/编辑认证机构列表
  OAgencyEdit: "/Organization/agencyEdit", // 超管添加/编辑认证机构
  UPoliticsSelectLists: "/User/politicsSelectLists", // 政治面貌选择列表
  UBloodtypeSelectLists: "/User/bloodtypeSelectLists", // 血型选择列表

  MYearDrillList: "/Drill/yearDrillList", // 当年演练列表
  MYearRescueList: "/Rescue/yearRescueList", // 年救援列表
  MYearSocialList: "/SocialService/yearSocialList", // 年社会服务列表
  MYearTrainList: "/Train/yearTrainList", // 年培训列表
  MYearTeamDrillList: "/Drill/yearTeamDrillList", // 当年演练列表(队伍)
  MYearTeamRescueList: "/Rescue/yearTeamRescueList", // 年救援列表(队伍)
  MYearTeamSocialList: "/SocialService/yearTeamSocialList", // 年社会服务列表(队伍)
  MYearTeamTrainList: "/Train/yearTeamTrainList", // 年培训列表(队伍)
  MYearDonateList: "/Donate/yearDonateList", // 年捐赠列表
  MDonateDetails: "/Donate/donateDetails", // 捐赠详细

  MyPpe: "/Ppe/myPpe", // 我的技能
  PpeAdd: "/Ppe/ppeAdd", // 添加技能
  PpeClass: "/Ppe/ppeClass", // 技能分类列表
  PpeAuditList: "/Ppe/ppeAuditList", // 技能审核列表
  PpeDetails: "/Ppe/ppeDetails", // 技能详情
  PpeAudit: "/Ppe/ppeAudit", // 技能审核
  PpeReviewProgress: "/Ppe/ppeReviewProgress", // 个人技能审核进度
  PpeEdit: "/Ppe/ppeEdit", // 编辑技能
  PpeClassList: "/Ppe/ppeClassList", // 分类技能列表

  companyClassList:"/YjCompany/companyClassList",//企业类型列表
  companyList:"/YjCompany/companyList",//企表列表
  getTeamName:"YjCompany/getTeamName", // 队伍列表(已开通服务号)
  companyAdd:"YjCompany/companyAdd",//添加企业
  companyDetails:"YjCompany/companyDetails",//企业详情
  companyEdit:"/YjCompany/companyEdit",//编辑企业
  companyDelete:"YjCompany/companyDelete",// 企业删除
  productAdd: "/YjProduct/productAdd", //添加商品
  YjhomeSearch:"YjSearch/homeSearch",// 兑换队员搜索
  coinSiteDetails:"YjCoinSite/coinSiteDetails",//获取核销地址
  coinSiteEdit:"/YjCoinSite/coinSiteEdit",//编辑核销地址


  talentPoolManage:"/YjIdentity/talentPoolManage",//人才库列表-管理
  RcgetTeamName:"/YjIdentity/getTeamName",//队伍列表-管理
  identityClassList:"/YjIdentity/identityClassList",//人才库类型
  setTalent:"/YjIdentity/setTalent",//设人才库-管理
  delTalent:"YjIdentity/delTalent",//取消人才库-管理
  

  productCLassList:"YjProduct/productClassList",//商品类型列表
  companyListProduct:"/YjCompany/companyListProduct",//企业列表(添加商品)
  productList: "/YjProduct/productList", //商品列表
  productDetails:"/YjProduct/productDetails",// 商品详情
  productEdit:"YjProduct/productEdit",// 编辑商品
  productCoinListAdimn:"YjProduct/productCoinListAdimn",//商品兑换记录(核销员)
  coinAdminListManage:"/YjProductCoinAdmin/coinAdminListManage",// 核销员列表-管理
  delCoinAdmin:"/YjProductCoinAdmin/delCoinAdmin",//取消核销员- 管理
  addCoinAdmin:"/YjProductCoinAdmin/addCoinAdmin",// 添加核销员-管理

  SendSMS: "/User/sendSMS", // 发送验证码
  SetPwd: "/User/setPwd", // 设置密码/实名验证
  ProvinceRankingList: "/User/provinceRankingList", // 省内排行
  NationwideRankingList: "/User/nationwideRankingList", // 全国排行
  ThisYearRescueList: "/Rescue/thisYearRescueList", // 当年救援列表
  LastYearRescueList: "/Rescue/LastYearRescueList", // 上一年救援列表
  // RescueDetails: "/Rescue/rescueDetails",  // 救援详情
  ThisYearTrainList: "/Train/thisYearTrainList", // 当年培训列表
  LastYearTrainList: "/Train/LastYearTrainList", // 上一年培训列表
  TrainGrade: "/Train/trainGrade", // 培训级别
  // TrainDetails: "/User/trainDetails",  // 培训详情
  ClassList: "/FeedbackProblemsClass/classList", // 反馈问题类型
  FeedbackProblemsAdd: "/FeedbackProblems/add", // 提交反馈问题
  ProblemsList: "/FeedbackProblems/problemsList", // 反馈问题列表
  ProblemsDetails: "/FeedbackProblems/problemsDetails", // 反馈问题详情
  Answer: "/FeedbackProblems/answer", // 反馈问题解答
  MyProblemsList: "/FeedbackProblems/myProblemsList", // 我的反馈问题列表
  ProblemsCancel: "/FeedbackProblems/cancel", // 取消反馈问题
  ImageUpload: "/ImageUpload/imageUpload", // 图片上传

  DonateAdd: "/Donate/add", // 个人捐赠
  DonateList: "/Donate/donateList", // 捐赠审核列表
  DonateAudit: "/Donate/audit", // 捐赠审核
  DonateLists: "/Donate/lists", // 捐赠列表
  DonateProvince: "/Donate/provinceList", // 省份列表（个人捐赠）
  DonateTeam: "/Donate/teamList", // 队伍列表（个人捐赠）
  DonateUser: "/Donate/userList", // 队员列表（个人捐赠）
  DonateSigningList: "/Donate/signingList", // 捐赠签收列表
  DonateSigningAudit: "/Donate/signingAudit", // 捐赠签收

  TrainList2: "/Train/trainList", // 培训任务（列表）
  TrainConfirm: "/Train/confirm", // 培训任务（确认）
  TrainCancel: "/Train/cancel", // 培训任务（取消）
  TrainSingin: "/Train/trainSingin", // 培训签到
  RTrainAudit: "/Train/audit", // 培训任务（审核）
  TrainAudit: "/Train/trainAudit", // 培训权限
  StartTrain: "/Train/startTrain", // 开始/结束培训
  StartTrainClassList: "/Train/startTrainClassList", // 开始/结束培训(班级列表)
  TrainHourComment: "/Train/trainHourComment", // 录入培训时长/评语
  CheckApplyUser: "/Train/checkApplyUser", // 查看报名人员
  SelectUserList: "/Train/selectUserList", // 选人开班列表
  SelectUser: "/Train/selectUser", // 选人开班
  TraintDetails: "/Train/traintDetails", // 培训详情（个人）
  TraintDetailsNew: "/Train/traintDetailsNew", // 培训详情（个人）新
  PublishTrainAudit: "/Train/publishTrainAudit", // 培训任务（审核）
  TAddUserApply: "/Train/addUserApply", // 培训任务重新报名
  HomeSearch: "/Search/homeSearch", //首页搜索
  MProvinceList: "/Message/provinceList", //省份列表（全国）
  MProvinceTeamAll: "/Message/provinceTeamAll", //省份队伍筛选

  ProvinceTeamDetails: "/Province/provinceTeamDetails", //省份详情

  PublishMessagetList: "/Message/publishMessagetList", //发布通知列表
  MessageGrade: "/Message/messageGrade", //通知级别
  MessageAuditList: "/Message/messageAuditList", //通知审核列表
  PublishMessagetDetails: "/Message/publishMessagetDetails", //通知详情
  PublishMessagetAudit: "/Message/publishMessagetAudit", //通知审核
  MessageAuditListList: "/Message/messageAuditListList", // 审核通知白名单（列表）
  MessageNationwideList: "/Message/messageNationwideList", // 发布全国通知白名单（列表）
  MessageNationwideListDelete: "/Message/messageNationwideListDelete", // 发布全国通知白名单（删除）
  MessageAuditDelete: "/Message/messageAuditDelete", // 审核通知白名单（删除）
  MessagetList: "/Message/messagetList", // 通知列表（个人）
  MessagetDetails: "/Message/messagetDetails", // 通知详情（个人）
  MessagetRead: "/Message/messagetRead", // 通知阅读
  ReadCondition: "/Message/readCondition", //查看阅读情况
  PositionIdentityList: "/Message/positionIdentityList", //职务、身份
  UserAll: "/Message/userAll", //职务、身份

  TrainNationwideList: "/Train/trainNationwideList", // 发布全国培训白名单（列表）
  TrainNationwideListDelete: "/Train/trainNationwideListDelete", // 发布全国培训白名单（删除）
  TrainNationwideListAdd: "/Train/trainNationwideListAdd", // 发布全国培训白名单（添加）
  TrainAuditListAdd: "/Train/trainAuditListAdd", // 审核培训白名单（添加）
  TrainAuditDelete: "/Train/trainAuditDelete", // 审核培训白名单（删除）
  TrainAuditListList: "/Train/trainAuditListList", // 审核培训白名单（列表）
  TrainAuditList: "/Train/trainAuditList", // 培训审核列表
  TrainTeamListAll: "/Train/teamListAll", // 全部队伍列表（培训）
  TrainProvinceList: "/Train/provinceList", // 省份列表（全国-培训）
  TrainProvinceTeamListAll: "/Train/provinceTeamListAll", // 多省份多队伍列表（培训）
  TrainGetTeamUserAll: "/Train/getTeamUserAll", // 多队伍多队员列表（培训）
  TrainCreate: "/Train/trainCreate", // 创建培训
  AddTrainUser: "/Train/addTrainUser", // 添加培训人员
  TrainEdit: "/Train/trainEdit", // 编辑培训
  TrainZhifu: "/Train/trainZhifu", // 培训支付
  MConfirmPay: "/mall/confirmPay", // 商城支付确认
  TConfirmPay: "/train/confirmPay", // 培训支付确认
  TrainHideTrain: "/Train/hideTrain", // 隐藏培训
  UserTrainAuditListAudit: "/Train/userTrainAuditListAudit", // 队员培训审核列表(队员审核)
  UserTrainAuditList: "/Train/userTrainAuditList", // 队员培训审核列表
  UserTrainAudit: "/Train/userTrainAudit", // 队员培训审核
  PublishTrainDetails: "/Train/publishTrainDetails", // 培训详情（管理员/权限）
  PublishTrainList: "/Train/publishTrainList", //发布培训列表
  tPositionIdentityList: "/Train/positionIdentityList", //职务、身份
  tUserAll: "/Train/userAll", //队员筛选
  tProvinceTeamAll: "/Train/provinceTeamAll", //省份队伍筛选

  ProvinceList: "/province/provinceList", //省份列表
  ProvinceCityList: "/province/provinceCityList", //省/市列表（地区设定）
  ManageDepartmentPrefix: "/province/manageDepartmentPrefix", //管理部门前缀
  EditCityCode: "/province/editCityCode", //修改城市编码
  EditTeamCode: "/province/editTeamCode", //修改队伍编码
  CityTeamList: "/province/cityTeamList", //城市（地区）队伍列表
  ProvinceTeamList: "/province/provinceTeamList", //省份队伍列表
  provinceTeamListAll: "/Message/provinceTeamListAll", //多省份多队伍列表
  TeamListAll: "/Message/teamListAll", //全部队伍列表
  GetTeamUserAll: "/Message/getTeamUserAll", //多队伍多队员列表
  GetTeamUserAllAdmid: "/Message/getTeamUserAllAdmid", //多队伍多队员列表（白名单）
  PublishMessage: "/Message/publishMessage", //发布通知
  MessageNationwideListAdd: "/Message/messageNationwideListAdd", // 发布全国通知白名单（添加）
  MessageAuditListAdd: "/Message/messageAuditListAdd", // 审核通知白名单（添加）
  MessageAudit: "/Message/messageAudit", //  通知权限
  MessageHideMessage: "/Message/hideMessage", //  隐藏通知

  PosttionList: "/TeamPosition/posttionList", //队伍职务列表
  RightsList: "/User/rightsList", //权限列表
  RightsList2: "/User/adminRightsList", //权限列表2
  MallListing: "/Mall/mallListing", //商品列表
  AdminMallListing: "/Mall/adminMallListing", //商品列表
  AdminMallDetail: "/Mall/adminMallDetails", //商品详情
  setLogistics: "/Mall/productSpecEdit", //商品规格编辑
  getLogistics: "/Mall/productSpecDetails", //商品规格详情
  getCity: "/DiQu/regions", // 获取省市区

  setGoodsDetail: "/Mall/adminMallAdd", //
  CardDetails: "/Mall/cardDetails", //工作证详情（管理系统）
  MallDetails: "/Mall/mallDetails", //商品详情
  MallClassAdd: "/MallClass/add", //添加商品分类
  MallClassEdit: "/MallClass/edit", //编辑商品分类
  MallClassListing: "/MallClass/listing", //商品分类列表
  MallPay: "/Mall/mallPay", //购买商品
  MallAuditList: "/Mall/mallAuditList", //装备审核列表
  MallAudit: "/Mall/mallAudit", //装备审核
  AdminMallAdd: "/Mall/adminMallAdd", //添加商品（管理系统）
  AdminMallEdit: "/Mall/adminMallEdit", // 编辑商品（管理系统）
  OrdersManageList: "/Orders/ordersManageList", // 订单列表（订单管理）
  OrdersExport: "/ExportData/export", // 订单列表（订单管理）
  OrdersManageDetails: "/Orders/ordersManageDetails", // 订单详情（订单管理）
  OrdersManageStatusEdit: "/Orders/ordersManageStatusEdit", // 修改订单状态（订单管理）
  MyOrdersList: "/Orders/myOrdersList", // 订单列表（我的订单）
  MyOrdersDetails: "/Orders/myOrdersDetails", // 订单详情（我的订单）
  MyOrdersConfirmReceipt: "/Orders/myOrdersConfirmReceipt", // 确认收货（我的订单）
  OrdersZhifu: "/Mall/ordersZhifu", // 订单支付（我的订单）
  OrdersRefund: "/Orders/ordersRefund", // 退款（订单管理）rightsList
  MyOrdersCancel: "/Orders/myOrdersCancel", // 取消订单（我的订单）
  ordersBuyMessageEdit: "/Orders/ordersBuyMessageEdit", //编辑买家留言
  MallNameListing: "/Search/mallNameListing", // 商品名称列表（筛选）
  ZipList: "/ExportData/zipList", // 导出数据压缩包列表
  ZipUnlink: "/ExportData/zipUnlink", // 删除压缩包
  DownloadZip: "/ExportData/downloadZip", // 下载压缩包
  JoinTeamList: "/Team/joinTeamList", //  转队/加入队伍审核列表
  JoinTeamAudit: "/Team/joinTeamAudit", //  转队(加入队伍)审核
  JoinTeam: "/Team/joinTeam", //  转队申请信息
  LeaveUserList: "/Team/leaveUserList", //  离队/下架列表
  LeaveRestore: "/Team/leaveRestore", //  离队（恢复）
  TvhpList: "/Team/tvhpList", // 荣誉(职位)编号列表
  TvhpAudit: "/Team/tvhpAudit", // 荣誉/职位编号审核
  CheckTvhp: "/Team/checkTvhp", // 查看荣誉（职位）编号
  TvhpDel: "/Team/tvhpDel", // 荣誉（职位）编号删除
  HonorbBsrno: "/Team/honorbBsrno", // 设置荣誉编号
  HonorbBsrnoCode: "/Team/honorbBsrnoCode", // 荣誉编号前缀
  UnderFrameTeam: "/Team/underFrameTeam", // 注销队伍
  HonorbBsrnoList: "/Team/honorbBsrnoList", // 荣誉编号选择成员列表
  HonorbBsrnoApply: "/Team/honorbBsrnoApply", // 申请使用荣誉编号
  TProvinceTeamListAll: "/Team/provinceTeamListAll", //根据省份获取队伍列表（转队/加入）
  TGetTeamUserAll: "/Team/getTeamUserAll", //根据队伍获取队员列表（转队/加入）
  TeamDynamicsList: "/Team/teamDynamicsList", //队伍动态列表
  TeamDynamicsAdd: "/Team/teamDynamicsAdd", //添加队伍动态
  TeamDynamicsOperateList: "/Team/teamDynamicsOperateList", //队伍动态操作记录列表
  TeamDynamicsSave: "/Team/teamDynamicsSave", //编辑队伍动态
  TeamDynamicsDel: "/Team/teamDynamicsDel", //删除队伍动态
  TeamOpenAdd: "/Team/teamOpenAdd", //添加队内公开信息
  OpenClassData: "/Team/openClassData", //公开类别数据
  TeamOpenList: "/Team/teamOpenList", //队内公开列表
  TeamOpenoPerateList: "/Team/teamOpenoPerateList", //队内公开记录列表
  TeamOpenSave: "/Team/teamOpenSave", //编辑队内公开
  TeamOpenDel: "/Team/teamOpenDel", //删除队内公开信息
  TeamOpenDetails: "/Team/teamOpenDetails", //队内公开详情
  LeaveTeamRestore: "/Team/LeaveTeamRestore", // 恢复原队伍

  getMallActivity: "MallActivity/getMallActivity", // 获取商品活动信息

  TeamStyleAdd: "/Team/teamStyleAdd", //添加队伍风采
  TeamStyleList: "/Team/teamStyleList", //队伍风采列表
  TeamStyleOperateList: "/Team/teamStyleOperateList", //队伍风采记录列表
  TeamStyleImg: "/Team/teamStyleImg", //队伍风采图片详情
  TeamStyleDel: "/Team/teamStyleDel", //删除队内风采
  TeamStyleSave: "/Team/teamStyleSave", //编辑队内风采
  TeamStyleImgDel: "/Team/teamStyleImgDel", //删除队内风采图片

  TeamAuthorizeAdd: "/Team/teamAuthorizeAdd", //添加队伍授权信息
  TeamAuthorizeList: "/Team/teamAuthorizeList", //授权信息审核列表
  TeamAuthorizeAudit: "/Team/teamAuthorizeAudit", //授权信息审核
  TeamAuthorize: "/Team/teamAuthorize", //队伍授权信息

  TeamEquipAdd: "/Team/teamEquipAdd", //添加队伍装备
  TeamEquipList: "/Team/teamEquipList", //队伍装备列表
  TeamEquipSave: "/Team/teamEquipSave", //编辑队伍装备
  TeamEquipOperateList: "/Team/teamEquipOperateList", //队伍装备记录列表
  TeamEquipDel: "/Team/teamEquipDel", //删除队伍装备
  TeamEquipDetails: "/Team/teamEquipDetails", //队伍装备详情

  UserAuditCount: "/AuditCount/userAuditCount", // 队员信息审核统计
  TeamAuditCount: "/AuditCount/teamAuditCount", // 队伍信息审核统计
  AllAuditCount: "/AuditCount/allAuditCount", // 审核统计
  HomeAuditCount: "/AuditCount/homeAuditCount", // 首页（培训/通知）审核统计

  CatData: "/Bigdata/catData", // 查看大数据
  CatDataNew: "/Bigdata/catDataNew", // 查看大数据
  CatDataNewUser: "/Bigdata/catDataNewUser", // 查看大数据
  SiginTimeList: "/Bigdata/siginTimeList", // 签到时间列表
  SiginTimeData: "/Bigdata/siginTimeData", // 个人签到数据
  SiginPersonalRate: "/Bigdata/siginPersonalRate", // 签到率详情
  ScreenProvinceList: "/Bigdata/screenProvinceList", // 省份列表(筛选)
  ScreenProvinceTeamList: "/Bigdata/screenProvinceTeamList", // 省份队伍列表(筛选)
  SiginData: "/Bigdata/siginData", // 签到数据（总览）
  SiginRate: "/Bigdata/siginRate", // 签到率
  SinginDataNationwideListAdd: "/Bigdata/singinDataNationwideListAdd", // 查看签到数据白名单（添加）
  SinginDataNationwideListDelete: "/Bigdata/singinDataNationwideListDelete", // 查看签到数据白名单（删除）
  SinginDataNationwideList: "/Bigdata/singinDataNationwideList", //  查看签到数据白名单（列表）
  SinginDataPermission: "/Bigdata/singinDataPermission", //  查看是否签到白名单
  LostEquip: "/Lost/lostEquip", //  挂失工作证
  LostEquipAudit: "/Lost/lostEquipAudit", //  挂失工作证审核
  LostEquipList: "/Lost/lostEquipList", //  挂失工作证审核列表
  AuditRights: "/WhiteList/auditRights", //  验证白名单审核权限

  ProvinceData: "/TeamAddress/provinceData", //  队部地址省份数据
  TeamData: "/TeamAddress/teamData", //  队部地址（队伍列表）
  TeamEditProvinceData: "/TeamAddress/teamEditProvinceData", // 管理员地址（数据）
  TeamAddressEdit: "/TeamAddress/teamAddressEdit", // 编辑地址信息
  TeamAddressDel: "/TeamAddress/teamAddressDel", // 删除队部地址信息
  TeamAddressExport: "/TeamAddressExportData/export", // 队部地址数据导出

  PpeClassAdd: "/PpeClass/add", //添加技能分类
  PpeClassDel: "/PpeClass/del", //删除技能分类
  PpeClassEdit: "/PpeClass/edit", //编辑技能分类
  PpeClassListing: "/PpeClass/listing", //技能分类列表
  PpeClassGrade: "/PpeClass/grade", //技能等级

  HandbookAdd: "/Handbook/add", //添加手册
  HandbookLists: "/Handbook/lists", //手册列表
  HandbookDetails: "/Handbook/details", //手册详情
  HandbookEdit: "/Handbook/edit", //编辑手册

  VersionsInfoList: "/Versions/versionsInfoList", //版本信息列表

  ReportsAddTask:"/YjTask/addTask",//发布任务
  editTask:"/YjTask/editTask",//任务编辑
  ReportstaskList:"/YjTask/taskList",//单队任务管理列表
  TaskDetails:"/YjTask/TaskDetails",//任务详情
  taskAllyGrade:"/YjTask/taskAllyGrade",//多队任务等级
  taskSecretstatus:"/YjTask/tasksecretstatus",//操作保密状态
  delTask:"/YjTask/delTask",//删除作务
  taskTeamAll:"YjTask/taskTeamAll",//出队队伍
  ReportsAdd: "/Reports/add", //添加工作简报
  ReportsOption: "/Reports/option", //默认或选项
  ReportsDetails: "/Reports/details", //报表详情
  ReportsLists: "/Reports/lists", //报表列表
  ReportsOperateList: "/Reports/operateList", //报表记录列表
  ReportsEdit: "/Reports/Edit", //编辑工作简报
  ReportsTask: "/Reports/task", //任务
  ReportsDurationList: "/Reports/durationList", //服务时长管理列表
  ReportsDuration: "/Reports/duration", //服务时长管理
  ReportsDurationRecordList: "/Reports/durationRecordList", //时长记录列表
  ReportsReportsType: "/Reports/reportsType", //工作简报类型
  ReportsReportsData: "/Reports/reportsData", //工作简报数据
  ReportsExport: "/TeamExportData/reportsExport", //工作报表数据导出
  ReportsSearchPlayer: "/Reports/searchPlayer", //报表白名单搜索队员
  ReportsAuthorizeArea: "/Reports/authorizeArea", //报表白名单授权地区
  ReportsAuthorizeAdd: "/Reports/authorizeAdd", //添加报表白名单
  ReportsTeamAll: "/Reports/teamAll", //多队管理
  ReportsAuthorizeList: "/Reports/authorizeList", //报表白名单列表
  ReportsAuthorizeDel: "/Reports/authorizeDel", //删除报表白名单
  ReportsGetTeamUserAll: "/YjTask/getTeamUserAll", //队员列表

  SinginAffirmSingin: "/Singin/affirmSingin", //确认签到
  SinginSinginList: "/Singin/singinList", //签到列表
  SinginIntegralList: "/Singin/integralList", //签到积分列表
  SinginGetIntegral: "/Singin/getIntegral", //领取积分
  SinginAffirmLeave: "/Singin/affirmLeave", //确认请假
  personalCenterContent: "/About/personalCenterContent", // 积分规则

  NewsNationwideListAdd: "/News/newsNationwideListAdd", //查看发布全国新闻白名单（添加）
  NewsNationwideListDelete: "/News/newsNationwideListDelete", //查看发布全国新闻白名单（删除）
  NewsNationwideList: "/News/newsNationwideList", //查看发布全国新闻白名单（列表）
  NewsAuditListAdd: "/News/newsAuditListAdd", //审核全国新闻白名单（添加）
  NewsAuditDelete: "/News/newsAuditDelete", //审核全国新闻白名单（删除）
  NewsAuditListList: "/News/newsAuditListList", //审核全国新闻白名单（列表）
  NewsAdd: "/News/add", //添加新闻
  NewsEdit: "/News/edit", //编辑新闻
  Newslevel: "/News/newslevel", //新闻级别
  NewsReleaseObject: "/News/releaseObject", //新闻发布对象
  NewsAuditList: "/News/auditList", // 新闻审核列表
  NewsDetails: "/News/details", // 新闻详情
  NewNewsDetails: "/News/newsDetails", // 新闻详情
  NewsReleaseList: "/News/releaseList", // 发布新闻列表
  NewsReview: "/News/review", // 发布新闻审核
  NewsOperateList: "/News/operateList", // 发布新闻操作记录
  NewsOperateDetails: "/News/operateDetails", // 操作记录详情
  NewsDel: "/News/newsDel", // 删除发布新闻
  NewsLists: "/News/lists", // 新闻列表
  NewsAuthority: "/News/authority", // 新闻审核管理接口
  NewsRecommend: "/News/recommend", // 推荐等级
  NewsRecommendList: "/News/recommendList", // 推荐等级列表
  NewsSearchPlayer: "/News/searchPlayer", // 新闻白名单搜索队员
  NewsAuthorizeArea: "/News/authorizeArea", // 新闻白名单授权地区
  NewsAuthorizeAdd: "/News/authorizeAdd", // 添加新闻白名单
  NewsAuthorizeList: "/News/authorizeList", // 新闻白名单列表
  NewsAuthorizeDel: "/News/authorizeDel", // 删除报表白名单
  NewsTeamNewsList: "/News/teamNewsList", // 队伍新闻列表
  NewsProvinceLists: "/News/provinceLists", // 省份新闻列表

  TeamFeaturesAuthorize: "/WhiteAuthority/teamFeaturesAuthorize", //队伍管理功能列表权限

  BottomMenuLists: "/BottomMenu/lists", //首页底部导航列表
  BottomMenuDetail: "/BottomMenu/detail", //底部导航页
  BottomMenuAdminLists: "/BottomMenu/adminLists", //管理员设置 首页导航信息列表
  BottomMenuAdminAdd: "/BottomMenu/adminAdd", // 管理员设置 添加底部导航
  BottomMenuAdminEdit: "/BottomMenu/adminEdit", // 管理员设置 修改底部导航
  BottomMenuAdminDelete: "/BottomMenu/adminDelete", // 管理员设置 删除底部导航
  BottomMenuMallListing: "/BottomMenu/mallListing", // 授权产品
  BottomMenuMallDetails: "/BottomMenu/mallDetails", // 授权产品详情
  BottomMenuClasslisting: "/BottomMenu/classlisting", // 授权产品分类

  EPositionalSelectLists: "/ExpertLibrary/positionalSelectLists", // 职称选择列表
  EAdminAdd: "/ExpertLibrary/adminAdd", // 添加专家库(管理系统)
  EAdminEdit: "/ExpertLibrary/adminEdit", // 职称选择列表
  EAdminDetail: "/ExpertLibrary/adminDetail", // 专家详细(管理系统)
  EAdminRelieve: "/ExpertLibrary/adminRelieve", // 专家解绑/绑定(管理系统)
  EAdminLists: "/ExpertLibrary/adminLists", // 专家库列表(管理系统)
  ELists: "/ExpertLibrary/lists", // 专家库列表
  EDetail: "/ExpertLibrary/detail", // 专家详细

  LostMessageAdminLists: "/LostMessage/adminAuditRecordList", // 寻人启事列表(管理员)
  LostMessageVistorLists: "/LostMessage/lists", // 寻人启事列表(公开)
  LostMessageDetail: "/LostMessage/userLostDetail", // 寻人启事详情(公开)
  LostMessageStatusLists: "/LostMessage/flagList", // 寻人启事列表(状态列表)
  LostMessageUserLists: "/LostMessage/userLists ", // 寻人启事列表(个人列表)
  LostMessageAdminAdd: "/LostMessage/adminAdd", // 添加寻人启事
  LostMessageAdminEdit: "/LostMessage/adminEdit", // 编辑寻人启事
  LostMessageAdminAudit: "/LostMessage/adminAuditRecord", // 审核寻人启事
  LostMessageAdminDelete: "/LostMessage/adminDelete", // 删除寻人启事
  FindRegister: "/LostMessage/registerUser", // 寻人启事·注册
  FindLogin: "/LostMessage/getToken", // 寻人启事·登录
  FindLogout: "/LostMessage/loginOut", // 寻人启事·退出登录

  ServerTime: "/User/serverTime", // 服务器时间

  LUserRanking: "/Leaderboard/userRanking", // 用户排行榜
  LTeamRanking: "/Leaderboard/teamRanking", // 队伍排行榜

  HSelectCategoryLists: "/Honor/selectCategoryLists", // 分类选择列表
  HSelectMoldLists: "/Honor/selectMoldLists", // 类目类型选择列表
  HSelectTypeLists: "/Honor/selectTypeLists", // 类目选择列表
  HAdminTypeAdd: "/Honor/adminTypeAdd", // 添加类目（管理系统）
  HAdminTypeEdit: "/Honor/adminTypeEdit", // 修改类目（管理系统）
  HAdminTypeLists: "/Honor/adminTypeLists", // 类目列表（管理系统）
  HAdminTypeDelete: "/Honor/adminTypeDelete", // 删除类目（管理系统）
  HAdminAdd: "/Honor/adminAdd", // 添加荣誉（管理系统）
  HAdminEdit: "/Honor/adminEdit", // 修改荣誉（管理系统）
  HAdminDelete: "/Honor/adminDelete", // 删除荣誉（管理系统）
  HAdminAuditLists: "/Honor/adminAuditLists", // 荣誉审核列表（管理系统）
  HAdminAudit: "/Honor/adminAudit", // 荣誉审核操作（管理系统）
  HAdminLists: "/Honor/adminLists", // 荣誉列表（管理系统）
  HProvinceLists: "/Honor/provinceLists", // 省荣誉列表
  HTeamLists: "/Honor/teamLists", // 队伍荣誉列表
  HUserLists: "/Honor/userLists", // 队员荣誉列表
  HAdminAuditTitle: "/Honor/adminAuditTitle", // 审核统计，审核标题
  HAdminLogLists: "/Honor/adminLogLists", // 荣誉记录列表（管理系统）

  TTaskHome: "/Task/home", // 报备首页
  TRoleLists: "/Task/roleLists", // 获取角色列表
  TRequestLists: "/Task/requestLists", // 新请求列表
  TRequestDetail: "/Task/requestDetail", // 请求详细
  TRequestEdit: "/Task/requestEdit", // 请求响应
  TExecuteLists: "/Task/executeLists", // 队员正在进行中任务列表
  TTaskLists: "/Task/taskLists", // 管辖正在执行的报备列表
  TLogLists: "/Task/logLists", // 历史任务列表
  TTeamSelectLists: "/Task/teamSelectLists", // 发布报备队伍选择列表
  TVolunteerSelectLists: "/Task/volunteerSelectLists", // 发布报备队长/文员选择列表
  TPpeSelectLists: "/Task/ppeSelectLists", // 技能人才选择列表
  TProvinceCityLists: "/Task/provinceCityLists", // 省市区列表
  TTeamLists: "/Task/teamLists", // 队伍列表

  CTAdd: "/CommonTask/add", // 添加一般报备
  CTPool: "/CommonTask/pool", // 报备池
  CTPoolAdd: "/CommonTask/poolAdd", // 报备池选择队员
  CTPoolDelete: "/CommonTask/poolDelete", // 报备池取消选择队员
  CTPoolEdit: "/CommonTask/poolEdit", // 报备池修改队长、文员
  CTPoolSubmit: "/CommonTask/poolSubmit", // 提交报备池
  CTTrimDetail: "/CommonTask/trimDetail", // 调整报备详情
  CTTrimEquipAdd: "/CommonTask/trimEquipAdd", // 调整报备 - 添加装备
  CTTrimEquipDelete: "/CommonTask/trimEquipDelete", // 调整报备 - 删除装备
  CTTeamRequestLists: "/CommonTask/teamRequestLists", // 队内请求列表
  CTTeamRequestAdd: "/CommonTask/teamRequestAdd", // 添加队内请求
  CTTeamRequestAudit: "/CommonTask/teamRequestAudit", // 指挥官审核请求
  CTLiveDetail: "/CommonTask/liveDetail", // 图文直播详细页
  CTLiveAdd: "/CommonTask/liveAdd", // 图文直播添加
  CTProcessDetail: "/CommonTask/processDetail", // 进程详细
  CTProcessTeamSelectLists: "/CommonTask/processTeamSelectLists", // 进程队伍选择列表
  CTProcessBtnLists: "/CommonTask/processBtnLists", // 进程按钮列表
  CTProcessAdd: "/CommonTask/processAdd", // 添加进程
  CTPpeSelectLists: "/CommonTask/ppeSelectLists", // 调整报备-技能人员选择列表
  CTTrimVolunteer: "/CommonTask/trimVolunteer", // 调整报备-添加普通队员页
  CTTrimVolunteerAdd: "/CommonTask/trimVolunteerAdd", // 调整报备-添加队员选择
  CTTrimVolunteerDelete: "/CommonTask/trimVolunteerDelete", // 调整报备-删除队员选择
  CTTrimVolunteerSubmit: "/CommonTask/trimVolunteerSubmit", // 调整报备-添加队员提交操作
  CTTrimPpe: "/CommonTask/trimPpe", // 调整报备-添加技能队员页
  CTTrimPpeAdd: "/CommonTask/trimPpeAdd", // 调整报备-添加技能队员选择
  CTTrimPpeDelete: "/CommonTask/trimPpeDelete", // 调整报备-删除技能队员选择
  CTTrimPpeSubmit: "/CommonTask/trimPpeSubmit", // 调整报备-队员选择列表
  CTSendRequest: "/CommonTask/sendRequest", // 调整报备-发送通知
  CTVolunteerSelectLists: "/CommonTask/volunteerSelectLists", // 调整报备-队员选择列表
  CTTrimLeadSubmit: "/CommonTask/trimLeadSubmit", // 调整报备-修改指挥官提交操作
  CTTrimClerkSubmit: "/CommonTask/trimClerkSubmit", // 调整报备-修改文员提交操作
  CTUnionAdd: "/CommonTask/unionAdd", // 联合队伍提交报备
  CTTrimCancel: "/CommonTask/trimCancel", // 调整报备队伍提交报备
  CTPoolResend: "/CommonTask/poolResend", // 重新发送请求，队长，文员
  CTPoolResends: "/CommonTask/poolResends", // 重新发送请求，拒绝列表

  BVideoList: "/BottomMenu/videoList", // 视频展播列表
  BVideoPlay: "/BottomMenu/videoPlay", // 视频展播播放

  SMProvinceList: "/SmsManage/provinceList", // 省份列表
  SMTeamList: "/SmsManage/teamList", // 队伍列表
  SMOverview: "/SmsManage/overview", // 短信服务概览
  SMUseDetailsList: "/SmsManage/useDetailsList", // 套餐包使用详情
  SMResourcePack: "/SmsManage/resourcePack", // 资源包规格
  SMStencilList: "/SmsManage/stencilList", // 模版列表
  SMSendRecordList: "/SmsManage/sendRecordList", // 发送记录查询
  SMSmsPay: "/SmsManage/smsPay", // 短信支付
  SMSConfirmPay: "/SmsManage/confirmPay", // 确认支付
  SMAuditList: "/SmsManage/auditList", // 购买短信审核列表
  SMReview: "/SmsManage/review", // 短信购买审核
  SMPositionIdentityList: "/SmsManage/positionIdentityList", //  职务、身份
  SMProvinceTeamAll: "/SmsManage/provinceTeamAll", // 在线发送(省份/队伍)
  SMUserAll: "/SmsManage/userAll", // 在线发送(队员筛选)
  SMSendMessages: "/SmsManage/sendMessages", // 在线发送短信
  SMRule: "/SmsManage/smsRule", // 短信规则

  SMautoTemplateList: "/SmsManage/autoTemplateList", //获取模板信息 1

  SMBDInfo: "/SmsManage/BDInfo", //生日模块设置信息
  SMjoinTeamInfo: "/SmsManage/joinTeamInfo", //入职模板设置信息

  SMBDEdit: "/SmsManage/BDEdit", //设置生日短信模板  1
  SMjoinTeamEdit: "/SmsManage/joinTeamEdit", //设置入职短信模板 1

  SMnoticeList: "/Versions/noticeList", //获取版本更新通知
  SMnoticeClick: "/Versions/noticeClick", //获取版本更新点击

  InsuraLists: "/Insurance/lists", // 保险列表
  InsuraLog: "/Insurance/log", // 保险列表修改记录
  InsuraEidt: "/Insurance/edit", // 修改未审核通过的保险
  InsuraUpload: "/Insurance/upload", // 上传保险
  InsuraOrderLists: "/Insurance/orderLists", // 保险订单列表
  InsuraOrderCancel: "/Insurance/orderCancel", // 取消保险订单
  InsuraAuditLists: "/InsuranceTm/auditLists", // 意外保险-审核列表
  InsuraAudit: "/InsuranceTm/audit", // 意外保险-审核操作
  InsuraAuditTitle: "/Insurance/auditTitle", // 意外保险-审核标题
  InsuraCheckInsurance: "/Insurance/checkInsurance", // 检查是否有保险
  DownloadInsurance: "/Download/insurance", // 下载保单
  InsuraDetail: "/InsuranceTm/detail", // 意外保险-保险详细
  InsuraOrderFormDetail: "/InsuranceTm/orderFormDetail", // 意外保险-下单填写信息
  InsuraOrderSubmit: "/InsuranceTm/orderSubmit", // 意外保险-下单操作
  InsuraOrderPay: "/InsuranceTm/orderPay", // 意外保险-支付，获取支付路径
  InsuraOrderState: "/InsuranceTm/orderState", // 意外保险-支付，支付后跳转页面调用接口
  InsuraNameSelectLists: "/Insurance/nameSelectLists", // 保险名称选择列表
  InsuraTypeSelectLists: "/Insurance/typeSelectLists", // 保险类型选择列表
  InsuraOrgAuditLists: "/InsuranceOrg/auditLists", // 组织者责任保险审核列表
  InsuraOrgAudit: "/InsuranceOrg/audit", // 组织者责任保险审核

  MallUserProvinceTeam: "/Mall/userProvinceTeam", // 商城大数据队员所属省份/队伍

  TeamApplyAuditCount: "/TeamApply/auditCount", //队伍申请审核统计和权限
  TeamApplySendSMS: "/TeamApply/sendSMS", //发送短信
  TeamimageUpload: "TeamApply/imageUpload", //上传图片
  TeamCheckTeamname: "/TeamPrep/checkTeamname", //查看队伍是否存在
  SearchVolunteer: "/TeamPrep/searchVolunteer", //添加队员信息组件搜索队员信息
  TeamGetInit: "/TeamPrep/getInit", //获取初始数据
  TeamProvinceCityList: "/TeamApply/provinceCityList", //获取所有城市数据
  TeamSetCacheVolunteer: "/TeamPrep/setCacheVolunteer", //设置队员缓存
  TeamPositionSelectList: "/TeamPrep/teampositionSelectList", //获取职务列表
  TeamSetCacheFile: "/TeamPrep/setCacheFile", //文件暂存
  TeamAdd: "/TeamPrep/add", //提交
  TeamLogin: "/TeamApply/login", //登录
  TeamLists: "/TeamPrep/lists", //申请列表
  TeamEditApply: "/TeamPrep/editApply", //修改申请人信息
  TeamEdit: "/TeamPrep/edit", //修改
  TeamDetail: "/TeamPrep/detail", //申请详情
  TeamPrepDelete: "/TeamPrep/delete", //删除申请
  TeamPrepGetFilePdf: "/TeamPrep/getFilePdf", //获取PDF

  PrepAuditlists: "/TeamPrepAudit/lists", //审核列表
  TeamPrepAuditDetail: "/TeamPrepAudit/detail", //审核详情
  TeamPrepAuditAuditFirst: "/TeamPrepAudit/auditFirst", //一级审核
  TeamPrepAuditAuditSecondary: "/TeamPrepAudit/auditSecondary", //二级审核
  TeamPrepAuditAllowLists: "/TeamPrepAudit/allowLists", //白名单列表
  TeamPrepAuditAllowAdd: "/TeamPrepAudit/allowAdd", //白名单添加
  TeamPrepAuditAllowDelete: "/TeamPrepAudit/allowDelete", //白名单删除

  TeamPrepAuthFileDetail: "/TeamPrep/authFileDetail", //授权文件详情
  TeamPrepAuthFileEdit: "/TeamPrep/authFileEdit", //授权文件修改
  TeamPrepAuthDetail: "/TeamPrep/authDetail", //授权信息
  TeamPrepAuthEdit: "/TeamPrep/authEdit", //授权信息修改
  TeamPrepAuditTeamAuthorizeList: "/TeamPrepAudit/teamAuthorizeList", //授权信息审核列表

  TeamPrepAuditTeamAuthorizeAudit: "/TeamPrepAudit/teamAuthorizeAudit", //授权信息审核
  TeamPrepAuditTeamAuthorizeAuditTotal:
    "/TeamPrepAudit/teamAuthorizeAuditTotal", //授权信息审核统计

  TeamApplyCheckFile: "/TeamApply/checkFile", //检查文件有效性

  ApplyUserSendSMS: "/ApplyUser/sendSMS", //发送短信
  ApplyUserRegister: "/ApplyUser/register", //注册
  ApplyUserLogin: "/ApplyUser/login", //登录
  ApplyUserLogout: "/ApplyUser/logout", //退出登录
  ApplyUserForgotPwd: "/ApplyUser/forgotPwd", //忘记密码

  InspectionHomeData: "/Inspection/homeData", //首页数据
  InspectionInspectorEchoList: "/Inspection/inspectorEchoList", //督查回声列表
  InspectionInspectorEchoDetails: "/Inspection/inspectorEchoDetails", //督查回声详情
  InspectionSubmitMessage: "/Inspection/submitMessage", //提交留言
  InspectionMyMessageList: "/Inspection/myMessageList", //我的留言列表
  InspectionMyMessageDetails: "/Inspection/myMessageDetails", //我的留言详情
  InspectionAreaList: "/Inspection/areaList", //获取区域列表
  InspectionAreaTeam: "/Inspection/areaTeam", //获取区域队伍
  InspectionMyMessageRevocation: "/Inspection/myMessageRevocation", //我的留言撤回

  SkillTrainRegions: "/DiQu/regions", //技能培训区域信息
  SkillTrainTransferList: "/PpeTrain/trainTransferList", //附近班列表
  SkillTrainNeighBouring: "/PpeTrain/neighBouring", //报名附近班
  SkillTrainCourselist: "/TrainingCourse/trainingCourselist", //培训科目列表
  SkillTrainApplyTrain: "/PpeTrain/applyTrain", //申请培训
  SkillTrainConfirmPay: "/PpeTrain/trainConfirmPay", //培训确认支付
  SkillTrainMyTrainings: "/MyTraining/myTrainings", //我的培训
  SkillTrainOrdersZhifu: "/PpeTrain/trainOrdersZhifu", //我的培训（订单支付）
  SkillTrainCancel: "/MyTraining/cancelTrain", //我的培训（取消）
  SkillTrainGuidance: "/PpetrainInform/registrationGuidance", //报名指引
  SkillTrainNotice: "/PpetrainInform/trainingNotice", //培训通知
  SkillTrainRecentClass: "/PpeTrain/recentTrainClass", //近期开班列表
  SkillTrainCourseDescription: "/Course/courseDescription", //培训课程介绍
  SkillTrainParticulars: "/MyTraining/particulars", //我的培训详情

  UserData: "/PrintReport/userData", //报表用户信息
  UserReport: "/PrintReport/userReport", //生成报表
  UserReportHistoryList: "/PrintReport/historyList", //历史报表

  UserAddress: "/ReceiverAddress/addressList", //收货地址
  delAddress: "/ReceiverAddress/addressDelete", // 删除收货地址
  editAddress: "/ReceiverAddress/addressEdit", // 编辑收货地址
  addAddress: "/ReceiverAddress/addressAdd", // 新增收货地址

  CartData: "/ShopCart/shopCartList", // 购物车列表
  CartJoin: "/ShopCart/shopCartJoin", // 加入购物车
  CartEdit: "/ShopCart/shopCartEdit", // 编辑购物车
  CartDel: "/ShopCart/shopCartDel", // 删除购物车
};



// WEBPACK FOOTER //
// ./src/api.jsx